import React, { CSSProperties } from "react"



interface CloseIconProps {
    size: number,
    className?: string;
    onClick?: (args?: any) => any;
}
export const CloseIcon = ({ size, className, onClick }: CloseIconProps) => {

    let style: CSSProperties = {
        fill: "none",
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "32px"
    }

    return (

        <svg width={size} height={size} className={className} viewBox="0 0 512 512" onClick={onClick}>
            <title>Fechar</title>
            <line x1="368" y1="368" x2="144" y2="144"
                style={style} />
            <line x1="368" y1="144" x2="144" y2="368"
                style={style} />
        </svg>
    )
}